import { useQueryClient } from "@tanstack/react-query"

import { useNetworksStateContext, useExtendWithSubnetworks } from "@l2r-front/l2r-networks"

import { API_MODULE_EQUIPMENT } from "../../../../../common/constants/modules"

import { equipmentQueryKeys } from "./queryKeys"
import { useEquipmentQuery } from "./useEquipmentQuery"


export function useEquipments(parameters = {}, config = {}) {
    const url = "equipments/"
    const { selectedNetwork } = useNetworksStateContext()

    const queryParameters = useExtendWithSubnetworks({
        ...parameters,
        project: selectedNetwork.slug,
    }, API_MODULE_EQUIPMENT)

    const queryKey = equipmentQueryKeys["layer"](queryParameters)

    return useEquipmentQuery(
        url,
        queryKey,
        queryParameters,
        {
            enabled: !!selectedNetwork,
            autoRefetch: true,
            ...config,
        },
    )
}

export const useExistingEquipment = (equipmentId, onError) => {
    const equipmentQueryKey = equipmentQueryKeys["feature"](equipmentId)
    equipmentQueryKey.pop()
    const layerQueryKey = equipmentQueryKeys["layer"]()
    layerQueryKey.pop()
    const queryClient = useQueryClient()

    const equipmentsDataFromLayer = queryClient.getQueriesData({ queryKey: layerQueryKey })
    const equipmentsData = queryClient.getQueriesData({ queryKey: equipmentQueryKey })

    const existingInEquipmentData = equipmentsData?.some(([_, equipment]) => {
        return (equipment?.id || equipment?.uuid) === equipmentId
    })
    const existingInEquipmentLayerData = equipmentsDataFromLayer?.some(([_, equipmentDataFromLayer]) => {
        if (equipmentDataFromLayer?.features) {
            return equipmentDataFromLayer.features?.some(equipment => equipment.id === equipmentId)
        } else {
            return equipmentDataFromLayer?.some(equipment => equipment.uuid === equipmentId)
        }
    })

    const existingEquipmentInCache = existingInEquipmentData || existingInEquipmentLayerData

    const { isLoading, isError } = useEquipment(equipmentId, {}, {
        enabled: !existingEquipmentInCache,
        onError,
    })

    return (!(isLoading || isError) || existingEquipmentInCache)
}

export function useEquipment(equipmentId, parameters = {}, config = {}) {
    const url = `equipments/${equipmentId}/`
    const { selectedNetwork } = useNetworksStateContext()

    const queryParameters = {
        ...parameters,
        project: selectedNetwork.slug,
    }

    const queryKey = equipmentQueryKeys["feature"](equipmentId, { ...parameters })

    return useEquipmentQuery(
        url,
        queryKey,
        queryParameters,
        {
            enabled: !!selectedNetwork,
            autoRefetch: true,
            ...config,
        },
    )
}